/**
 * @generated SignedSource<<d49430053d87ab71a3697830f0b675cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NewPhaseItem_project$data = {
  readonly id: number;
  readonly is_template: boolean;
  readonly team_id: number | null | undefined;
  readonly " $fragmentType": "NewPhaseItem_project";
};
export type NewPhaseItem_project$key = {
  readonly " $data"?: NewPhaseItem_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"NewPhaseItem_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NewPhaseItem_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "is_template",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "team_id",
      "storageKey": null
    }
  ],
  "type": "projects",
  "abstractKey": null
};

(node as any).hash = "664e834a4ad7d9a411b83cfdd6cd63c2";

export default node;
